export default {
    name: 'HatenaCommentListItem',
    mounted() {
        if (this.$refs["script-holder"]) {
            let scriptEl = document.createElement('script');
            scriptEl.setAttribute('src', 'https://adm.shinobi.jp/st/t.js');
            scriptEl.setAttribute('type', 'text/javascript');
            scriptEl.setAttribute('charset', 'utf-8');
            scriptEl.setAttribute('async', 'async');
            this.$refs["script-holder"].appendChild(scriptEl);
        }
    },
    props: ['comment', 'index'],
    computed: {
        time: function () {
            let unixTime = parseInt(this.comment.timestamp);
            let d = new Date(unixTime * 1000);
            let year = d.getFullYear();
            let month = d.getMonth() + 1;
            let dayOfMonth = d.getDate();
            let hour = ('0' + d.getHours()).slice(-2);
            let min = ('0' + d.getMinutes()).slice(-2);

            return year + "/" + month + "/" + dayOfMonth + " " + hour + ":" + min;
        }
    }
}

